// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }
  
  InstantSearchResultItemProduct.prototype.compileTemplate = function(){
    if (this.isShow) {
        var searchTerm = Utils.stripHtml(Globals.currentTerm);
        // Product image
        var imageHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
          imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
          imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
        }
        // Product title
        var productTitle = this.customizeProductTitle();
        productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
        // SKU
        var skuHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
          skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
          skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
        }
        // Vendor
        var vendorHTML = '';
        if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
          vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
          vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
        }
        // Price
        var priceHTML = this.compileSuggestionProductPrice();
        // Open the result item in new tab when selected
        var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
        var newUrl ='';
        if(this.url.indexOf('cart') > 0){
          newUrl = this.url.slice(5, this.url.length)
        }else {
          newUrl = this.url
        }

        return this.getTemplate()
          .replace(/{{id}}/g, this.id)
          .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
          .replace(/{{url}}/g, newUrl)
          .replace(/{{newTabAttribute}}/g, newTabAttr)
          .replace(/{{itemProductImage}}/g, imageHTML)
          .replace(/{{title}}/g, productTitle)
          .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
          .replace(/{{itemProductSku}}/g, skuHTML)
          .replace(/{{itemProductVendor}}/g, vendorHTML)
          .replace(/{{itemProductPrice}}/, priceHTML)
          .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
          .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
          .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
      } else {
        return '';
      }
  }
})();